import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import { SSOAuthProviderKey } from 'types/sso';

const firebaseConfig = {
  apiKey: 'AIzaSyAexQvSYzaMyb2BnfSSuC8txQd7z_LVl_Y',
  authDomain: 'altify-app.firebaseapp.com',
  projectId: 'altify-app',
  storageBucket: 'altify-app.appspot.com',
  messagingSenderId: '479154074188',
  appId: '1:479154074188:web:fd57523d055714a6567ae9',
  measurementId: 'G-DKTZ6RSC9V',
};

initializeApp(firebaseConfig);

async function getAppleProvider() {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');

  return provider;
}

async function getGoogleProvider() {
  const provider = new GoogleAuthProvider();
  provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
  provider.addScope('https://www.googleapis.com/auth/userinfo.email');

  return provider;
}

async function getAuthProvider(provider: SSOAuthProviderKey) {
  switch (provider) {
    case 'GOOGLE':
      return getGoogleProvider();
    case 'APPLE':
      return getAppleProvider();
  }
}

export async function firebaseAuthenticate(providerType: SSOAuthProviderKey) {
  const provider = await getAuthProvider(providerType);
  const result = await signInWithPopup(getAuth(), provider);
  const token = (result.user as any).accessToken;
  return { user: result.user, token };
}

export const firebaseLogout = async () => {
  const auth = getAuth();
  if (auth.currentUser && auth.currentUser?.email) {
    await auth.signOut();
  }
};
